import {
  ColumnDetail,
  ComplexSelectionFormValue,
  RowDetail,
} from '../../../../../../../ui/gzSelectableTableRowGroup/types';
import {
  ContentControlNetworkMonitorAttackTechnique,
  ContentControlNetworkMonitorAttackTechniqueAction,
  ContentControlNetworkMonitorAttackTechniqueName,
} from '@nirvana/shared/dtos/types/policies/common';
import { translateFn } from '../../../../../../../utils/translator.helper';

export enum ContentControlNetworkMonitorAttackTechniqueKey {
  INITIAL_ACCESS = 'initialAccess',
  CREDENTIAL_ACCESS = 'credentialAccess',
  DISCOVERY = 'discovery',
  LATERAL_MOVEMENT = 'lateralMovement',
  CRIMEWARE = 'crimeware',
}

function getKeyByName() {
  return {
    [ContentControlNetworkMonitorAttackTechniqueName.INITIAL_ACCESS]:
      ContentControlNetworkMonitorAttackTechniqueKey.INITIAL_ACCESS,
    [ContentControlNetworkMonitorAttackTechniqueName.CREDENTIAL_ACCESS]:
      ContentControlNetworkMonitorAttackTechniqueKey.CREDENTIAL_ACCESS,
    [ContentControlNetworkMonitorAttackTechniqueName.DISCOVERY]:
      ContentControlNetworkMonitorAttackTechniqueKey.DISCOVERY,
    [ContentControlNetworkMonitorAttackTechniqueName.LATERAL_MOVEMENT]:
      ContentControlNetworkMonitorAttackTechniqueKey.LATERAL_MOVEMENT,
    [ContentControlNetworkMonitorAttackTechniqueName.CRIMEWARE]:
      ContentControlNetworkMonitorAttackTechniqueKey.CRIMEWARE,
  };
}

function getNameByKey() {
  return {
    [ContentControlNetworkMonitorAttackTechniqueKey.INITIAL_ACCESS]:
      ContentControlNetworkMonitorAttackTechniqueName.INITIAL_ACCESS,
    [ContentControlNetworkMonitorAttackTechniqueKey.CREDENTIAL_ACCESS]:
      ContentControlNetworkMonitorAttackTechniqueName.CREDENTIAL_ACCESS,
    [ContentControlNetworkMonitorAttackTechniqueKey.DISCOVERY]:
      ContentControlNetworkMonitorAttackTechniqueName.DISCOVERY,
    [ContentControlNetworkMonitorAttackTechniqueKey.LATERAL_MOVEMENT]:
      ContentControlNetworkMonitorAttackTechniqueName.LATERAL_MOVEMENT,
    [ContentControlNetworkMonitorAttackTechniqueKey.CRIMEWARE]:
      ContentControlNetworkMonitorAttackTechniqueName.CRIMEWARE,
  };
}

export const columns = (): ColumnDetail<ContentControlNetworkMonitorAttackTechniqueAction>[] => {
  return [
    {
      column: ContentControlNetworkMonitorAttackTechniqueAction.REPORT_ONLY,
      label: translateFn('Report only'),
    },
    {
      column: ContentControlNetworkMonitorAttackTechniqueAction.BLOCK_PROCESS,
      label: translateFn('Block'),
    },
  ];
};

export const rows = (): RowDetail<
  ContentControlNetworkMonitorAttackTechniqueKey,
  ContentControlNetworkMonitorAttackTechniqueAction
>[] => [
  { key: ContentControlNetworkMonitorAttackTechniqueKey.INITIAL_ACCESS, label: translateFn('Initial Access') },
  { key: ContentControlNetworkMonitorAttackTechniqueKey.CREDENTIAL_ACCESS, label: translateFn('Credential Access') },
  { key: ContentControlNetworkMonitorAttackTechniqueKey.DISCOVERY, label: translateFn('Discovery') },
  { key: ContentControlNetworkMonitorAttackTechniqueKey.LATERAL_MOVEMENT, label: translateFn('Lateral Movement') },
  { key: ContentControlNetworkMonitorAttackTechniqueKey.CRIMEWARE, label: translateFn('Crimeware') },
];

export function convertDbValueToFormValue(
  categories: ContentControlNetworkMonitorAttackTechnique[],
  enforcedColumnValue?: ContentControlNetworkMonitorAttackTechniqueAction
): ComplexSelectionFormValue<
  ContentControlNetworkMonitorAttackTechniqueKey,
  ContentControlNetworkMonitorAttackTechniqueAction
> {
  const keyByName = getKeyByName();
  const uiValue = {};

  categories.forEach(category => {
    uiValue[keyByName[category.name]] = {
      // use key instead of name
      enabled: category.enable,
      column: enforcedColumnValue ?? category.action,
    };
  });

  return uiValue;
}

export function convertFormValueToDbValue(
  categories: ComplexSelectionFormValue<
    ContentControlNetworkMonitorAttackTechniqueKey,
    ContentControlNetworkMonitorAttackTechniqueAction
  >
): ContentControlNetworkMonitorAttackTechnique[] {
  const nameByKey = getNameByKey();
  const dbValue: ContentControlNetworkMonitorAttackTechnique[] = [];

  Object.entries(categories).forEach(([key, value]) => {
    dbValue.push({
      name: nameByKey[key], // convert key to name
      enable: value.enabled,
      action: value.column,
    });
  });

  return dbValue;
}
